import React from 'react';
import { useForm, ValidationError } from '@formspree/react';

function Contact() {
  const [state, handleSubmit] = useForm("movjgdeo");
  return (
    <div className='contactform content_wrapper'>
      <div className="title_area">
        <div className="title_content">
          <h2>조각보에 문의합니다</h2>
          <p>성별정정툴킷 사이트에 관한 의견을 남겨주세요.</p>
        </div>
      </div>
      {
        state.succeeded ? <div className='aftersubmit'>문의해주셔서 감사합니다.</div>
        :
        <div className="main_content">
      <div className='desc'>
          <p>이곳에는 성별정정툴킷 사이트에 관한 의견을 남겨 주세요. 작성해주신 내용은 조각보만 조회 가능하며, 작성해주신 이메일을 통해 답변드리도록 하겠습니다. 자세한 상담은 <a href='https://transgender.or.kr/47'>조각보 사이트의 상담 게시판</a>을 이용 바랍니다.</p>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="email">
            <label htmlFor="email">
              이메일 주소
            </label>
            <input
              required
              id="email"
              type="email"
              name="email"
              placeholder='답변 받을 이메일을 작성해 주세요.'
              autoComplete='email' />
        </div>
        <ValidationError 
          prefix="Email" 
          field="email"
          errors={state.errors}
        />
        <textarea
          required
          id="message"
          name="message"
          placeholder='조각보는 의료기관에의 동행 및 재정적 지원 요청, 사법 및 행정과 관련된 서류 작성 요구, 법원에의 동행 요청 등, 오프라인 상에서의 조력을 원칙적으로 제공하지 않습니다.' />
        <ValidationError 
          prefix="Message" 
          field="message"
          errors={state.errors} />
        <button type="submit" disabled={state.submitting}>
          보내기
        </button>
      </form>
      </div>
      }
      
    </div>
  );
}

export default Contact